export default {
  apiUrl: process.env.REACT_APP_VUICS_API_URL || 'https://api.vuics.com/latest',
}
